module.exports = __webpack_public_path__ + "static/img/TheApartmentLoungeImage@3x.bdf33a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/places/TheApartmentLoungeImage@3x.png
// module id = NZ2N
// module chunks = 0